module.exports = __webpack_public_path__ + "img/instagram.fc23b902.svg";